export default "__VITE_ASSET__B0nkjnU6__"